/* eslint new-cap: ["error", { "newIsCap": false }] */
/* eslint no-param-reassign: 0 */
import axios from 'axios';
import decode from 'jwt-decode';
import moment from 'moment-timezone';
// SENTRY STUFFS
import Raven from 'raven-js';
// import _ from 'lodash';

const HttpClient = (baseUrl) => {
  const $http = new axios.create({
    baseURL: baseUrl,
    timeout: process.env.API_TIMEOUT_INTERVAL,
  });
  // this.$http = $http;
  return {
    getTokenExpirationDate(token) {
      if (token === null) return null;
      try {
        const decoded = decode(token);
        if (!decoded.exp) {
          return null;
        }
        return moment(decoded.exp, 'X').tz(process.env.DEFAULT_TZ);
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    getInstance() {
      return $http;
    },
    sendRequest(method, url, data, headers, cb) {
      const commonHeader = $http.defaults.headers.common;
      let shouldUnsetCommonHeader = false;
      if (headers !== null && headers.UNSET_COMMON_HEADER) {
        shouldUnsetCommonHeader = true;
        delete headers.UNSET_COMMON_HEADER;
      }
      // merge header
      let targetHeaders = commonHeader;
      if (headers !== null) {
        if (shouldUnsetCommonHeader) {
          targetHeaders = headers;
          $http.defaults.headers.common = {};
        } else {
          // targetHeaders = _.merge(headers, commonHeader);
          targetHeaders = commonHeader;
          // add/override headers
          Object.keys(headers).forEach((headerKey) => {
            targetHeaders[headerKey] = headers[headerKey];
          });
        }
      }
      $http.request({
        url,
        method,
        headers: targetHeaders,
        // headers,
        data,
      }).then((res) => {
        if (shouldUnsetCommonHeader) {
          $http.defaults.headers.common = commonHeader;
        }
        cb(null, this.getResponseData(res));
      }).catch((err) => {
        if (shouldUnsetCommonHeader) {
          $http.defaults.headers.common = commonHeader;
        }
        cb(this.getErrorData(err), null);
      });
    },
    getResponseData(res) {
      if (res.data) {
        return res.data;
      }
      return null;
    },
    getErrorData(err) {
      if (window.appConfig.SENTRY_URL) {
        // check if error has response or not
        Raven.captureException(err, {
          extra: {
            err_payload: JSON.parse(JSON.stringify(err)),
          },
        });
      }
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (err.response.data) {
          if (err.response.data.auth_code) {
            return err.response.data.auth_code;
          }
          if (err.response.data.error_message) {
            return err.response.data.error_message;
          }
          if (err.response.data.message) {
            return err.response.data.message;
          }
          return err.response.data;
        }
        return 'Unexpected error';
      } else if (err.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser
        return err.message;
      } else if (err.message) {
        return err.message;
      }
      return 'Unexpected error';
    },
    isAuthenticated(token) {
      return typeof token === 'string';
    },
    /* isValidToken(token) {
      return new Promise((resolve, reject) => {
        const tokenExpired = this.isTokenExpired(token);
        if (tokenExpired) {
          reject('Login expired');
        } else {
          $http.post('/auth/verify-token', { token }).then(() => {
            resolve();
          }).catch((err) => {
            // check if error is network or not
            // console.error('catch verify token', getErrorData(err));
            reject(err);
          });
        }
      });
    }, */
    setJWTToken(jwt) {
      $http.defaults.headers.common.Authorization = `Bearer ${jwt}`;
    },
    removeJWTToken() {
      $http.defaults.headers.common.Authorization = null;
    },
    isTokenExpired(token) {
      const date = this.getTokenExpirationDate(token);
      if (date === null) {
        return false;
      }
      return date.diff(moment().tz(process.env.DEFAULT_TZ)) <= 0;
    },
  };
};

export default HttpClient;



// WEBPACK FOOTER //
// ./src/libs/http.js